import { render, staticRenderFns } from "./award.vue?vue&type=template&id=25d29e77&scoped=true"
import script from "./award.vue?vue&type=script&lang=js"
export * from "./award.vue?vue&type=script&lang=js"
import style0 from "./award.vue?vue&type=style&index=0&id=25d29e77&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d29e77",
  null
  
)

export default component.exports